/**
 * Resolves a path to a file in the public folder for dev and production builds.
 * CRA sets PUBLIC_URL to "." when homepage is ".", which breaks relative asset
 * paths on nested client routes unless normalized to a root-absolute path.
 */
export function getPublicAssetUrl(relativePath) {
  const normalizedPath = String(relativePath || "").replace(/^\//, "");

  let publicPrefix = process.env.PUBLIC_URL || "";
  if (publicPrefix === ".") {
    publicPrefix = "";
  }
  publicPrefix = publicPrefix.replace(/\/$/, "");

  const combinedPath = publicPrefix
    ? `${publicPrefix}/${normalizedPath}`
    : `/${normalizedPath}`;

  if (typeof window !== "undefined") {
    try {
      return new URL(combinedPath, window.location.origin).href;
    } catch (error) {
      console.warn("Unable to resolve public asset URL:", combinedPath, error);
    }
  }

  return combinedPath;
}

export default getPublicAssetUrl;
